<script setup>
import { useNavigationToCards } from '#imports';

const props = defineProps({
  navigationItems: {
    type: Array,
    required: true,
  },
});
const { scrollToElement, activeLinkId, showNavigation } = useNavigationToCards(
  props.navigationItems
);
</script>

<template>
  <div class="navigation-mobile">
    <button
      class="navigation-mobile__trigger"
      @click="showNavigation = !showNavigation"
    >
      <img src="~/assets/images/list.svg" alt="navigation button" />
    </button>
    <Teleport to="body">
      <BaseMobileModal
        v-if="showNavigation"
        is-dark
        @close="showNavigation = false"
      >
        <ul class="navigation-mobile__list">
          <li
            v-for="(item, index) in navigationItems"
            :key="item.id"
            class="navigation-mobile__item"
            :class="{
              'navigation-mobile__item--active': activeLinkId === item.id,
            }"
            @click="scrollToElement(item.id)"
          >
            {{ index + 1 }}. {{ item.text }}
          </li>
        </ul>
      </BaseMobileModal>
    </Teleport>
  </div>
</template>

<style lang="postcss" scoped>
.navigation-mobile {
  &__trigger {
    display: flex;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background-color: var(--accent-color);
    cursor: pointer;

    img {
      width: 22px;
      height: 20px;
      margin: auto;
    }
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__item {
    padding: 16px;
    border-radius: 16px;
    color: var(--white-color);
    background-color: rgba(248, 249, 250, 20%);
    transition: var(--default-transition) background-color;

    &--active {
      color: var(--black-color);
      background-color: rgba(255, 246, 251, 96%);
    }
  }
}
</style>
